
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Skills } from "./components/Skills";
import { Projects } from "./components/Projects";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { Filter } from './components/Filter';

import {I18nextProvider} from 'react-i18next';
import i18next from 'i18next';

import global_es from './translations/es/global.json'
import global_en from './translations/en/global.json'
import global_dk from './translations/dk/global.json'
import { Timeline } from './components/Timeline';
/* https://coolors.co/9e788f-f7f4ff-8b8cbc-1e2479-151515-121212 */

i18next.init({
  interpolation:{escapeValue:false},
  lng:"es",
  resources:{
    es:{global:global_es},
    en:{global:global_en},
    dk:{global:global_dk}
  }
})

function App() {
  return (
    <I18nextProvider i18n={i18next}>
      <div className="App">
        <Filter />
        <NavBar />
        <Banner />
        <Skills />
        <Timeline/>
        <Projects />
        <Contact />
        <Footer />
      </div>
    </I18nextProvider>
  );
}

export default App;
